export const PATH_PARAMETERS_INTERFACES = "/parameters/interfaces";
export const PATH_PARAMETERS_INTERFACES_DATA_SHARING = `${PATH_PARAMETERS_INTERFACES}/data-sharing`;
export const PATH_PARAMETERS_INTERFACES_DATA_SHARING_ID = `${PATH_PARAMETERS_INTERFACES}/data-sharing/:id`;
export const PATH_PARAMETERS_INTERFACES_THIRD_PARTY = `${PATH_PARAMETERS_INTERFACES}/third-party`;
export const PATH_PARAMETERS_INTERFACES_THIRD_PARTY_ID = `${PATH_PARAMETERS_INTERFACES_THIRD_PARTY}/:id`;

export const DEFAULT_QR_CODE_WIDTH = 300;
export const DEFAULT_QR_CODE_HEIGHT = 300;

export const DEFAULT_SORT_INTERFACE_DATASHARING = "-createdAt";
